import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { TypeOfGraveViewController, TypeOfGraveViewControllerDelegate } from "../../Screen/TypeOfGrave/TypeOfGraveViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { TypeOfGraveViewModel } from '../../Screen/TypeOfGrave/TypeOfGraveViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class TypeOfGraveCoordinator implements IndexCoordinatorDelegate, TypeOfGraveViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geptipotumulo")
        return (<ProtectedRoute requiredPermissions={['cemiterio.tipo_tumulo.*']} path="/:base/tipo-tumulo" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'cemiterio.tipo_tumulo.adicionar',
                    edit: 'cemiterio.tipo_tumulo.editar',
                    delete: 'cemiterio.tipo_tumulo.excluir',
                }} 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Tipo de Túmulo"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new TypeOfGraveViewModel()
        return (<ProtectedRoute requiredPermissions={['cemiterio.tipo_tumulo.adicionar', 'cemiterio.tipo_tumulo.editar']} path="/:base/tipo-tumulo/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<TypeOfGraveViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geptipotumulo") {
            navigation.history.push(`tipo-tumulo/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geptipotumulo") {
            navigation.history.push(`tipo-tumulo/cad/${idSelection}`);
            return;
        }
    }

}